import { render, staticRenderFns } from "./modal_add_keyword.vue?vue&type=template&id=4267adcb&scoped=true&"
import script from "./modal_add_keyword.vue?vue&type=script&lang=js&"
export * from "./modal_add_keyword.vue?vue&type=script&lang=js&"
import style0 from "./modal_add_keyword.vue?vue&type=style&index=0&id=4267adcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4267adcb",
  null
  
)

export default component.exports